import { render, staticRenderFns } from "./NarrationButtons.vue?vue&type=template&id=54ce462f&"
import script from "./NarrationButtons.vue?vue&type=script&lang=js&"
export * from "./NarrationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ce462f')) {
      api.createRecord('54ce462f', component.options)
    } else {
      api.reload('54ce462f', component.options)
    }
    module.hot.accept("./NarrationButtons.vue?vue&type=template&id=54ce462f&", function () {
      api.rerender('54ce462f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NarrationButtons.vue"
export default component.exports